import { z } from "zod";
// The printed code is the same everywhere and carries nothing, so which session
// a participant's feedback belongs to is worked out from who they are.
//
// The surname is sent only once the server has asked for it, which it does when
// the first name alone describes more than one person in the window.
//
// Name shape is not validated — real ICIS names carry odd spacing, case and
// punctuation, and the server compares a normalised form.
export const SubmitChallengeSchema = z.object({
    firstName: z.string().min(1).max(200),
    surname: z.string().min(1).max(200).optional(),
});
/**
 * Either the participant is identified, or a surname is needed to tell them from
 * someone else of the same first name.
 *
 * Asking for the second field reveals that the first one matched more than one
 * person in the window. That is a known cost of the staged design, accepted so a
 * first name alone can serve the nine in ten participants it does identify.
 */
export const ChallengeResultSchema = z.discriminatedUnion("outcome", [
    z.object({ outcome: z.literal("identified"), invitationId: z.guid() }),
    z.object({ outcome: z.literal("surname-needed") }),
]);
